// src/lib/config.js
// All values come from environment variables injected at build time
// See .env.example for required variables

const config = {
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  cognito: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  },
  apiUrl: process.env.REACT_APP_API_URL,
  // Read-only archive mode — set at build time (deploy.sh, from cdk.json "archived").
  // When true, the UI shows a banner and blocks all write requests client-side;
  // the backend enforces the same as a 403 regardless of this flag.
  archiveMode: process.env.REACT_APP_ARCHIVE_MODE === 'true',
};

export default config;
